(function() { window.GUID_d479b43a_c89a_41f8_a1b8_25ed566ed854 = { getGuid: function() { return "d479b43a-c89a-41f8-a1b8-25ed566ed854"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class StatsGraph extends Controls.ControlBase {
            get ControlId() {
                return this.$control.attr('id');
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                let me = this;
                this.$control = $(params[0]);
            }
            OnBindEvents() {
            }
            OnDispose() {
                this.$control.remove();
            }
        }
        Controls.StatsGraph = StatsGraph;
        (function (StatsGraph) {
            class Events {
            }
            StatsGraph.Events = Events;
            class EventNames {
            }
            EventNames.Click = "button-click";
            StatsGraph.EventNames = EventNames;
        })(StatsGraph = Controls.StatsGraph || (Controls.StatsGraph = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=stats-graph.js.map
